import { LatLng } from 'leaflet'

export function calculateDistanceBetweenCoordinates(startCoordinates, endCoordinates) {
  const startLocation = new LatLng(startCoordinates[0], startCoordinates[1])
  const endLocation = new LatLng(endCoordinates[0], endCoordinates[1])
  const distance = startLocation.distanceTo(endLocation)
  return distance
}
